import React, {Component} from 'react';
import {Grid, Loader} from 'semantic-ui-react';
import EventList from '../EventList/EventList';
// import EventForm from '../EventForm/EventForm'; import cuid from 'cuid';
import {connect} from 'react-redux';
import {compose} from 'redux'
import {firestoreConnect} from 'react-redux-firebase';
import {getEventsForDashboard} from '../eventActions';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import EventActivity from '../EventActivity/EventActivity';

const query = [
    {
        collection: 'activity',
        orderBy: [
            'timestamp', 'desc'
        ],
        limit: 8
    }
]

class EventDashBoard extends Component {
    // constructor(props){   super(props);   this.state = {     isOpen: false,
    // selectedEvent: null   } this.handleFormOpen = this.handleFormOpen.bind(this);
    // this.handleCancel = this.handleCancel.bind(this); } show create from
    // handleFormOpen = () =>{   this.setState({     selectedEvent: null, isOpen:
    // true   }) } hide create form handleCancel = () => {   this.setState({
    // isOpen:false   }) }   handleUpdateEvent = (updatedEvent) => {
    // this.props.updateEvent(updatedEvent);     this.setState({       isOpen:
    // false,       selectedEvent: null     })  } click VIEW and show specific event
    // onEventOpen={handleOpenEvent} pass to EventList & EventListItem, return
    // parms(event), show selectedevent in EventForm handleOpenEvent = (eventToOpen)
    // => () => {   this.setState({     selectedEvent: eventToOpen,     isOpen: true
    //   }) } create new event handleCreateEvent = (newEvent) => { newEvent.id =
    // cuid();   newEvent.hostPhotoURL = '/assets/user.png'
    // this.props.createEvent(newEvent);   this.setState({     isOpen: false   }) }
    state = {
        moreEvents: false,
        loadingInitial: true,
        loadedEvents: [],
        contextRef: {}
    }

    async componentDidMount() {
        let next = await this
            .props
            .getEventsForDashboard();
        console.log(next);
        if (next && next.docs && next.docs.length > 0) {
            this.setState({moreEvents: true, loadingInitial: false})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.events !== nextProps.events) {
            this.setState({
                loadedEvents: [
                    ...this.state.loadedEvents,
                    ...nextProps.events
                ]
            })
        }
    }

    getNextEvents = async() => {
        const {events} = this.props;
        let lastEvent = events && events[events.length - 1];
        //console.log(lastEvent);
        let next = await this
            .props
            .getEventsForDashboard(lastEvent);
        //console.log(next);
        if (next && next.docs && next.docs.length <= 1) {
            this.setState({moreEvents: false})
        }
    }

    handleDeleteEvent = (eventId) => () => {
        this
            .props
            .deleteEvent(eventId);
    }

    handleContextRef = contextRef => this.setState({contextRef})
    render() {

        const {loading, activities} = this.props;
        const {moreEvents, loadedEvents} = this.state;
        if (this.state.loadingInitial) 
            return <LoadingComponent inverted={true}/>
        return (
            <Grid>
                <Grid.Column width={10}>
                    <div ref={this.handleContextRef}>
                        <EventList
                            events={loadedEvents}
                            loading={loading}
                            moreEvents={moreEvents}
                            getNextEvents={this.getNextEvents}/>
                    </div>
                </Grid.Column>
                <Grid.Column width={6}>
                    <EventActivity activities={activities} contextRef={this.state.contextRef}/>
                </Grid.Column>
                <Grid.Column width={10}>
                    <Loader active={loading}/>
                </Grid.Column>
            </Grid>
        )
    }
}

const mapState = (state) => ({
    // events: state.firestore.ordered.events, loading: state.async.loading
    events: state.events,
    loading: state.async.loading,
    activities: state.firestore.ordered.activity
})

const actions = {
    // deleteEvent,
    getEventsForDashboard
}

//listen to event
export default compose(firestoreConnect(query), connect(mapState, actions))(EventDashBoard);



// WEBPACK FOOTER //
// ./src/features/event/EventDashBoard/EventDashBoard.jsx